import { useState } from 'react';
import { FORM_FACTORS_MAP, useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { bonusesActions } from '../../store';

const {
  FETCH_FREE_SPINS_BONUSES_HISTORY_DATA,
  FETCH_MORE_FREE_SPINS_BONUSES_HISTORY
} = bonusesActions;

export const useFreeSpinBonusesHistoryFetchCallbacks = () => {
  const { t } = useI18n();
  const [isFetchingBonuses, setIsFetchingBonuses] = useState(true);
  const [isFetchingMoreBonuses, setIsFetchingMoreBonuses] = useState(false);
  const [isInitialLoaded, setIsInitialLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const { errorNotification } = useNotifications();
  const { isMobile, isTablet } = useDeviceStore();
  const platform =
    isMobile || isTablet ? FORM_FACTORS_MAP.MOBILE : FORM_FACTORS_MAP.DESKTOP;

  const loadBonusesHistoryList = async () => {
    try {
      setIsFetchingBonuses(true);
      await FETCH_FREE_SPINS_BONUSES_HISTORY_DATA({
        filter: {
          currentPage: 1
        },
        platform
      });
    } catch {
      errorNotification(t(`accountingMessages.accounting_error_6`));
    } finally {
      setIsFetchingBonuses(false);
    }

    setIsInitialLoaded(true);
  };

  const loadMoreBonusesHistoryList = async () => {
    try {
      setIsFetchingMoreBonuses(true);
      await FETCH_MORE_FREE_SPINS_BONUSES_HISTORY({
        filter: {
          currentPage: page + 1
        },
        platform
      });
      setPage((prevState) => prevState + 1);
    } catch {
      errorNotification(t(`accountingMessages.accounting_error_6`));
    } finally {
      setIsFetchingMoreBonuses(false);
    }
  };

  return {
    isFetchingBonuses,
    isFetchingMoreBonuses,
    loadBonusesHistoryList,
    loadMoreBonusesHistoryList,
    isInitialLoaded
  };
};
